var _path, _circle, _g, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLuxembourg = function SvgLuxembourg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h200v200H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Luxembourg_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 189,
    height: 189
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 99.5,
    r: 94.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Luxembourg_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Luxembourg_svg__b)",
    d: "M0 5h314v189H0z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 100.5,
    r: 94,
    stroke: "#B6B6B6",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "Luxembourg_svg__b",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Luxembourg_svg__c",
    transform: "matrix(.00222 0 0 .0037 0 -.054)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "Luxembourg_svg__c",
    width: 450,
    height: 300,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcIAAAEsAgMAAAAtOFskAAAADFBMVEX////vKy0Ao90AAAD0zO4pAAAAGXRFWHRTb2Z0d2FyZQBHcmFwaGljQ29udmVydGVyNV1I7gAAAIRJREFUeJzszTENADAIADAk8uBv91SigYeEpDXQqGUZRqPRaDQajUaj0Wg0Go1Go9FoNBqNRqPRaDQajUaj0Wg0Go1Go/H6CAAAAAAAAAAAAAAw9Zc9o9FoNBqNRqPRaDQajUaj0Wg0Go1Go9FoNBqNRqPRaDQajUaj0Xh9bAAAAP//AwBEGPSGhHk2jwAAAABJRU5ErkJggg=="
  }))));
};
export default SvgLuxembourg;